export const GOOGLE_SITE_KEY = "6Lcee0UaAAAAAMB-68meGsAN-kT6Bu6DidBOQfmN";
export const END_USER_AGREEMENT_VERSION=1;